import { z } from "zod";

export const siteSchema = z.object({
	id: z.string().optional().nullable(),
	client_id: z.string().optional().nullable(),
	site_code: z.string().min(1, "Site code is required"),
	description: z.string().optional().nullable(),
	project_id: z.number().optional().nullable(),
	project_name: z.string().optional().nullable(),
	latitude: z.number().min(1, "latitude code is required"),
	longitude: z.number().min(1, "longitude is required"),
	plus_code: z.string().min(1, "Plus code is required"),
	kit_number: z.string().min(1, "Kit Number is required"),
	address: z.string().optional().nullable(),
	city: z.string().optional().nullable(),
	region: z.string().optional().nullable(),
	island: z.string().optional().nullable(),
	location_name: z.string(),
	locality: z.string().min(1, "Locality is required"),
	province: z.string().min(1, "Province is required"),
	country: z.string().optional().nullable(),
	access_point: z.string().optional().nullable(),
	mbr: z.string().optional().nullable(),
	availability: z.number().optional().nullable(),
	disabled_at: z.string().optional().nullable(),
	is_active: z.boolean().optional(),
	is_disabled: z.boolean().optional(),
	created_at: z.string().optional().nullable(),
	updated_at: z.string().optional().nullable(),
	deleted_at: z.string().optional().nullable(),
});

export type Site = z.infer<typeof siteSchema>;
